import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ClusterInterface } from '../../common/types/interfaces'

const initialState: {
  cluster: ClusterInterface | undefined
  imageUrl: string | ''
  documentUrl: string | ''
} = {
  cluster: undefined,
  imageUrl: '',
  documentUrl: '',
}

export const currentClusterSlice = createSlice({
  name: 'current-cluster',
  initialState,
  reducers: {
    setCurrentCluster: (state, action: PayloadAction<ClusterInterface | undefined>) => {
      state.cluster = action.payload
      localStorage.setItem('currentCluster', JSON.stringify(action.payload))
      if (action.payload) {
        state.imageUrl = `/sales-api/${action.payload.port}/${action.payload.token}/api/v1/data/file?path=`
        state.documentUrl = `/sales-api/${action.payload.port}/${action.payload.token}/api/v1/document`
      }
    },
    resetCurrentCluster: (state) => {
      state.cluster = undefined
    },
  },
})

export const { setCurrentCluster } = currentClusterSlice.actions
export const { resetCurrentCluster } = currentClusterSlice.actions
export const selectCurrentCluster = (state: RootState) => state.currentCluster.cluster
export const selectClusterImageUrl = (state: RootState) => state.currentCluster.imageUrl
export const selectClusterDocumentUrl = (state: RootState) => state.currentCluster.documentUrl

export default currentClusterSlice.reducer
